import React from "react";
import { useNavigate } from "react-router-dom";
import { X, Sparkles, Check, MessageCircle, Camera, Siren, Dog } from "lucide-react";

const PERKS = [
  { icon: MessageCircle, label: "Unlimited AI chat questions" },
  { icon: Camera, label: "Photo symptom analysis" },
  { icon: Siren, label: "Emergency red-flag detection" },
  { icon: Dog, label: "Personalized advice per dog" },
];

export default function UpgradeModal({ open, onClose, used, limit, soft }) {
  const navigate = useNavigate();
  if (!open) return null;

  const title = soft
    ? "That was your last free question"
    : `You've used all ${limit || 3} free questions`;
  const subtitle = soft
    ? "That was your last free AI question this month. Upgrade to Wooflect Pro for unlimited chats and scans."
    : "Upgrade to Wooflect Pro for unlimited chats and keep caring for your pup without limits.";

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/40" onClick={onClose}>
      <div className="bg-white w-full max-w-md rounded-3xl overflow-hidden" onClick={(e) => e.stopPropagation()} data-testid="upgrade-modal">
        <div className="relative bg-gradient-to-br from-[#E86A45] to-[#d65f3c] text-white p-6 pt-7">
          <button onClick={onClose} className="absolute top-4 right-4 h-9 w-9 rounded-full bg-white/20 flex items-center justify-center" data-testid="upgrade-close">
            <X size={18} color="#fff" />
          </button>
          <div className="h-14 w-14 rounded-2xl bg-white/20 flex items-center justify-center mb-3">
            <Sparkles size={28} />
          </div>
          <h2 className="font-display text-2xl font-black">{title}</h2>
          <p className="text-white/90 mt-1 text-sm">{subtitle}</p>
        </div>
        <div className="p-6">
          <div className="space-y-2.5">
            {PERKS.map((p) => (
              <div key={p.label} className="flex items-center gap-3">
                <div className="h-8 w-8 rounded-xl bg-[#F6DED5] flex items-center justify-center shrink-0">
                  <Check size={16} color="#E86A45" />
                </div>
                <span className="font-semibold text-[#2D2B2A]">{p.label}</span>
              </div>
            ))}
          </div>
          <button
            data-testid="upgrade-modal-cta"
            onClick={() => {
              onClose();
              navigate("/app/subscription?highlight=pawpal_pro");
            }}
            className="w-full mt-6 rounded-full bg-[#E86A45] text-white font-extrabold py-3.5 hover:bg-[#d65f3c] transition-colors"
          >
            Upgrade to Pro
          </button>
          <button onClick={onClose} className="w-full mt-2 py-2 text-sm font-bold text-[#9A938B]" data-testid="upgrade-maybe-later">
            Maybe later
          </button>
        </div>
      </div>
    </div>
  );
}
